<template>
  <div
      :class="['block', className]"
      :style="{
          'transform': !visible ? '' :
              step <= 4
              ? 'translate(' + cx + 'px, ' + cy + 'px)'
              : 'translate(' + left + 'px, ' + top + 'px) scale(' + lscale + ')',
          'will-change': step > 4 ? 'transform' : '',
          'display': visible ? '' : 'none'
      }"
  >
    <div v-if="vl >= 1">
      <div
          v-for="item of bigSquares"
          :key="Math.random(item)">
        <div
            v-if="scale >= 3 + 0.1 * step"
            :style="{
            transform: 'translate(' + item.x * step + 'px, ' + item.y * step + 'px) rotate(' + item.rotate + 'deg)',
            width: step * 0.35 + 'px',
            height: step * 0.35 + 'px'
          }"
        ></div>
      </div>
    </div>
    <div v-if="vl >= 2">
      <div
          v-for="item of mediumSquares"
          :key="Math.random(item)">
        <div
            v-if="scale >= 9 + 0.15 * step"
            :style="{
            transform: 'translate(' + item.x * step + 'px, ' + item.y * step + 'px) rotate(' + item.rotate + 'deg)',
            width: step * 0.15 + 'px',
            height: step * 0.15 + 'px'
          }"
        ></div>
      </div>
    </div>
    <div v-if="vl >= 3">
      <div
          v-for="item of smallSquares"
          :key="Math.random(item)">
        <div
            v-if="scale >= 17 + 0.2 * step"
            :style="{
            transform: 'translate(' + item.x * step + 'px, ' + item.y * step + 'px) rotate(' + item.rotate + 'deg)',
            width: step * 0.05 + 'px',
            height: step * 0.05 + 'px'
          }"
        ></div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "BaseBrick",
  props: {
    x: Number,
    y: Number,
    tx: Number,
    ty: Number,
    l1x: Number,
    l1y: Number,
    l2x: Number,
    l2y: Number,
    step: Number,
    scale: Number,
    className: String,
    cw: Number,
    ch: Number,
    vl: Number
  },
  data: () => ({
    bigSquares: [],
    mediumSquares: [],
    smallSquares: []
  }),
  computed: {
    cx () {
      return this.step < 2 || this.step > 4
          ? this.x * this.step
          : this.step === 2
              ? 2 * (this.x - this.l1x)
              : 4 * (this.x - this.l2x);
    },
    cy () {
      return this.step < 2 || this.step > 4
          ? this.y * this.step
          : this.step === 2
              ? 2 * (this.y - this.l1y)
              : 4 * (this.y - this.l2y);
    },
    lscale () {
      return this.scale / this.step;
    },
    lWidth () {
      return 40 * this.step;
    },
    lHeight () {
      return 40 * this.step;
    },
    left () {
      return this.x * this.scale + this.tx;
    },
    right () {
      return this.left + this.lWidth * this.scale;
    },
    top () {
      return this.y * this.scale + this.ty;
    },
    bottom () {
      return this.top + this.lHeight * this.scale;
    },
    hVisible () {
      return this.left < this.cw && this.right > 0;
    },
    vVisible () {
      return this.top < this.ch && this.bottom > 0;
    },
    visible () {
      return (this.hVisible && this.vVisible && this.step > 4) || this.step <= 4;
    }
  },
  created () {
    for (let i = 0; i < 10; i++) {
      this.bigSquares.push({
        x: Math.random() * 30,
        y: Math.random() * 30,
        rotate: Math.random() * 90,
        step: i
      });
    }

    for (let i = 0; i < 40; i++) {
      this.mediumSquares.push({
        x: Math.random() * 35,
        y: Math.random() * 35,
        rotate: Math.random() * 90,
        step: i
      });
    }

    for (let i = 0; i < 50; i++) {
      this.smallSquares.push({
        x: Math.random() * 38,
        y: Math.random() * 38,
        rotate: Math.random() * 90,
        step: i
      });
    }
  }
}
</script>
